import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import {Subject} from 'rxjs';
import { city } from 'src/app/shared/classes/city';
import { Country } from 'src/app/shared/classes/Country';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { CitiesService } from 'src/app/shared/services/cities.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
// import { LoaderService } from 'src/app/shared/services/loader.service';

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.less']
})

export class AddCityComponent implements OnInit, OnDestroy {
  public cityData: city[] = [];
  public CountryData:Country[] = [];
  CountrySelected:number;
  CitySelected: number;
  DateChanged:Date;
  changedBy:string;
  AddedBy:string;
  cityName: string;
  addedBy:string;
  MasterList: any;
  CityList:any;
  Cities:any;
  city:any;
  Status:any;
  selectActiveStatus: {isChecked: boolean} = {isChecked : true};
  selectInActiveStatus: {isChecked: boolean} = {isChecked : false};
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  @ViewChild('addCityForm') addCityForm: NgForm;
  constructor(
    private _dataContextService: DataContextService,
    private _masterService: MasterService,
    public modalRef: BsModalRef,
    private httpClient : HttpClient,
    private toast: ToastrService,
    private citiesService: CitiesService,
    private trackeromnitureservice:TrackerOmnitureService
    // private loaderService: LoaderService
  ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit() {
    // this.httpClient.get('https://localhost:8081/master/getCityMasterData').subscribe((res)=>{
    //   console.log(res);
    //   }) 
    this.getData();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('city-add',username);
    this.trackeromnitureservice.trackPage("pageView");
  }

  OnchangeCountry(event){
  //  this.cityData=this.MasterList.cityData.filter((item)=>
  this.cityData=this.cityData.filter((item)=>
   {  
    return item.countryId===this.CountrySelected
   })
  }


  AddNewCity(city) {
    //Converting selected status to boolean
    if (this.addCityForm.valid) {
      if (this.selectActiveStatus.isChecked) {
        this.Status = true;
      }
      else {
        this.Status = false;
      }

      //Finding object of selected country
      var co = this.CountryData.find(obj => obj.countryId = this.CountrySelected);

      //var ci = this.cityData.find(obj => obj.cityName= city);
      
      var ci = this.cityData.find((obj) => {
        return obj.cityName.toLowerCase().trim() === city.toLowerCase().trim();
      });
      //Fetching user name from local storage
      var userName = localStorage.getItem('email');


      if(ci!=null)
      {
       this.toast.error("City are already Exist!");
       this.modalRef.hide();
       return ;
      }
      else{
        let params = {
          CityName: city,
          //CityID: this.CitySelected,
          //cityName: ci.cityName,
          AddedBy:userName,
          //DateChanged:this.DateChanged,
          //ChangedBy:'yrathod@deloitte.com',
          City: this.cityName,
          IsActive: this.Status,
          CountryID: this.CountrySelected,
          countryName: co.countryName
        };

        this._dataContextService.postDatawithValues<any>(this.service_URL.CityDetails.AddNewCity, params)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
         // console.log(res);
          this.modalRef.hide();
          //this.loaderService.show();
          this.citiesService.refreshwithFilters.next();        
            this.toast.success("Successfully added City details!");      
        });   
      }    
      }
     else {
      this.toast.error("Unable to save City details!");
    }
}

  getData(){
    //CityMasterData API/
    this._masterService.getCityMasterData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.MasterList = data;
      this.CityList=data;
      //this.Cities=data;
        
       //Add Countries to CountryData List
       for(var i=0;i<this.MasterList.length;i++){
        var _cd = new Country();
        _cd.countryId = this.MasterList[i].countryID;
        _cd.countryName = this.MasterList[i].countryName;
        this.CountryData.push(_cd);
      }

     //// Add Cities to CityData List
      for(var i=0;i<this.MasterList.length;i++){
        this.MasterList[i].cityList.forEach(element => {
          var _cy = new city();
          _cy.cityId = element.cityID;
          _cy.cityName = element.cityName;
          _cy.countryId = element.countryID;
         _cy.countryName = element.CountryName

          this.cityData.push(_cy);
        })
       }
    })
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
